import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
export const extractTextFromReact = (node) => {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    const html = renderToStaticMarkup(_jsx(_Fragment, { children: node }));
    return html.replace(/(<([^>]+)>)/ig, '');
};
